import React from 'react';
import { BaseLastNameInput } from 'src/components/enterprise/components/BaseLastNameInput/BaseLastNameInput';

export interface LastNameControlProps {
  name: string;
  id: string;
}

export const LastNameControl: React.FC<LastNameControlProps> = ({
  name,
  id,
}) => {
  return (
    <BaseLastNameInput
      name={name}
      id={id}
      rules={{
        required: 'Last Name is required',
      }}
    />
  );
};
